var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H2.30453L4.74074 9.95473H14.3539L16 3.89712H3.35802",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20359 13.7086C7.20359 14.5961 6.48411 15.3156 5.59659 15.3156C4.70907 15.3156 3.98959 14.5961 3.98959 13.7086C3.98959 12.821 4.70907 12.1016 5.59659 12.1016C6.48411 12.1016 7.20359 12.821 7.20359 13.7086Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8416 13.7086C14.8416 14.5961 14.1221 15.3156 13.2346 15.3156C12.3471 15.3156 11.6276 14.5961 11.6276 13.7086C11.6276 12.821 12.3471 12.1016 13.2346 12.1016C14.1221 12.1016 14.8416 12.821 14.8416 13.7086Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.453bc759497a024461590ad1a8118626.svg";
export { ForwardRef as ReactComponent };